/**
 * Mixin for selected list utilities
 */
export default {
  data() {
    return {
      selectItems: this.value,
    }
  },
  methods: {
    isSelected(obj) {
      return this.selectItems.includes(obj)
    },
    onItemsClick(obj, maxSelectedNum) {
      const index = this.selectItems.indexOf(obj)
      const isExist = index !== -1

      if (!isExist) {
        if (maxSelectedNum && this.selectItems.length >= maxSelectedNum) {
          // Reach max number
          this.$emit('on-max-error')
        } else {
          // Selected item
          this.selectItems.push(obj)
        }
      } else {
        // Deselect item
        this.selectItems.splice(index, 1)
      }
    },
    onSingleSelectItem(obj) {
      const index = this.selectItems.indexOf(obj)
      const isExist = index !== -1

      if (!isExist) {
        this.selectItems = []
        this.selectItems.push(obj)
      } else {
        // Deselect item
        this.selectItems.splice(index, 1)
      }
    },
  },
  props: {
    value: {
      default: () => [],
      type: Array,
    },
  },
  watch: {
    selectItems(newValue) {
      this.$emit('input', newValue)
    },

    value(newValue) {
      this.selectItems = newValue
    },
  },
}
